@if (form) {
  <div class="filter-bar">
    <form [formGroup]="form" class="active-filters">
      <div class="filter">
        <label [for]="'searchField-' + searchControlName">
          {{ searchLabel }}
          @if (searchTooltip) {
            <i-lucide
              name="help-circle"
              [ngbTooltip]="searchTooltip"
            ></i-lucide>
          }
        </label>
        <input
          [name]="'searchField-' + searchControlName"
          [id]="'searchField-' + searchControlName"
          type="search"
          class="form-control search-field"
          autocomplete="off"
          [placeholder]="searchPlaceholder"
          [formControlName]="searchControlName"
        />
      </div>
      @for (filter of activeFilters; track filter) {
        <div class="filter">
          <label>{{ filter.label }}</label>
          <button
            type="button"
            class="btn-close"
            aria-label="Close"
            (click)="removeFilter(filter)"
          ></button>
          <ng-container #filterViewRef></ng-container>
        </div>
      }
      @if (showAddFilterButton) {
        <div ngbDropdown class="aa-dropdown add-filters" placement="bottom-end">
          <button
            ngbDropdownToggle
            type="button"
            class="btn btn-outline-dark"
            [disabled]="!hasAvailableFilters()"
          >
            <i-lucide name="filter"></i-lucide>
            Add Filter
          </button>

          <div ngbDropdownMenu>
            @for (
              filter of availableFilters;
              track filter;
              let index = $index
            ) {
              @if (filter.isHeader) {
                <h5 class="ms-3 me-2 mt-2">
                  {{ filter.label }}
                </h5>
              }

              @if (!filter.isHeader && !activeFilters.includes(filter)) {
                <button
                  ngbDropdownItem
                  type="button"
                  (click)="showFilter(filter)"
                >
                  {{ filter.label }}
                </button>
              }
            }
          </div>
        </div>
      }
    </form>
    <div class="filter-controls">
      @if (showColumnsButton && columnConfig) {
        <div
          ngbDropdown
          class="aa-dropdown"
          placement="bottom-end"
          autoClose="outside"
        >
          <button ngbDropdownToggle type="button" class="btn btn-outline-dark">
            <i-lucide name="columns"></i-lucide>
            Columns
          </button>

          <div ngbDropdownMenu>
            @for (
              column of columnConfig.allColumns;
              track column;
              let i = $index
            ) {
              <div [formGroup]="$any(form.controls[columnsControlName])">
                @if (shouldShowColumn(column.value)) {
                  <div class="form-check pt-1 ms-2 mb-1">
                    <input
                      [id]="'filter-column-' + column.value"
                      type="checkbox"
                      class="form-check-input"
                      [formControlName]="column.value.toString()"
                    />
                    <label
                      [for]="'filter-column-' + column.value"
                      class="form-check-label"
                    >
                      {{ column.label }}
                    </label>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }
      @if (showClearButton) {
        <button
          type="button"
          (click)="clear()"
          class="btn btn-outline-dark ms-2"
        >
          <i-lucide name="ban"></i-lucide>
          Clear
        </button>
      }
    </div>
  </div>
}
